export const Content = `
<p>
<a href="http://www.varden.se">Vården.se</a>
hämtar in informationen från den officiella databasen med alla vårdgivare i Sverige,
den så kallade HSA-katalogen. Om du ser information som inte stämmer kan du meddela
det här genom att fylla i ett formulär.
</p>
<p>
Observera att vi bara tar hand om information som rör denna sida.
Vi har ingen kontakt med denna enhet, vilket gör att du inte kan ta kontakt
med mottagningen via detta formulär. Du kan inte heller få svar på medicinska frågor,
avboka eller boka om tider eller förnya recept här.
</p>
<p>
Behöver du sjukvårdsrådgivning rekommenderar vi att du ringer 1177.
Vid livshotande besvär ska du alltid ringa 112.
</p>

`;
